import { useEffect, useRef } from "react";
import { useTurnstileReady } from "../hooks/useTurnstileReady";
import { Spinner } from "./spiner";

declare global {
  interface Window {
    turnstile?: {
      render: (
        el: HTMLElement,
        opts: {
          sitekey?: string;
          appearance?: "execute" | "always" | "invisible";
          callback?: (token: string) => void;
          [key: string]: any;
        }
      ) => number;
      remove: (id: number) => void;
    };
  }
}

type Props = {
  siteKey: string;
  appearance?: "execute" | "always" | "invisible";
  onVerify: (token: string) => void;
};

export default function Turnstile({
  siteKey,
  appearance = "execute",
  onVerify,
}: Props) {
  const ref = useRef<HTMLDivElement>(null);
  const ready = useTurnstileReady();

  useEffect(() => {
    if (!ready || !ref.current) return;

    const widgetId = window.turnstile!.render(ref.current, {
      sitekey: siteKey,
      appearance: 'execute',
      callback: onVerify,
      language: "en",
    });

    return () => {
      window.turnstile?.remove(widgetId);
    };
  }, [ready, siteKey, appearance, onVerify]);

  if (!ready) {
    return (
      <div
        style={{
          padding: 16,
          textAlign: "center",
          color: "#666",
          fontSize: 13,
        }}
      >
        <Spinner />
        Loading security challenge…
      </div>
    );
  }

  return <div ref={ref} />;
}
